<!-- No asset types message -->
<div
  class="flex-row align-items-center justify-content-center"
  style="margin: 0 auto; padding: 48px"
  *ngIf="noAssetTypes && !loading"
>
  {{ 'core.no_asset_types_found' | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div
  class="table-wrapper"
  [class.loading]="loading"
  [style.min-height.px]="containerHeight"
  *ngIf="!noAssetTypes"
>
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table mat-table [dataSource]="items" class="spotlab-table" matSort [class.dimmed]="loading">
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.type' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        <i
          [class.ri-image-2-line]="item.type === 'image'"
          [class.ri-film-line]="item.type === 'video'"
          [class.ri-file-text-line]="item.type === 'text'"
          [class.ri-music-line]="item.type === 'audio'"
        >
        </i>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetType">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.name' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item" class="name-cell">
        {{ item.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="usedByCaseTypes">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.casetypes' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        <ts-loading-attribute
          icon="ri-article-line"
          [value]="item.usedByCaseTypes"
          class="flex-row align-items-center justify-left"
        ></ts-loading-attribute>
      </td>
    </ng-container>

    <ng-container matColumnDef="usedByMethodTypes">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.method_types' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        <ts-loading-attribute
          icon="ri-archive-line"
          [value]="item.usedByMethodTypes"
          class="flex-row align-items-center justify-left"
        ></ts-loading-attribute>
      </td>
    </ng-container>

    <ng-container matColumnDef="compatibleDevices">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.compatible_devices' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item" class="last-data-cell">
        <ts-loading-attribute
          icon="ri-device-line"
          [value]="item.supportedDevices"
          class="flex-row align-items-center justify-left"
        ></ts-loading-attribute>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item" class="icon-cell">
        <button
          class="icon-button"
          type="button"
          (click)="editClicked.emit(item); $event.stopPropagation()"
          data-cy="asset-type-edit"
        >
          <i class="ri-pencil-line"></i>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item" class="icon-cell">
        <button
          class="icon-button danger"
          type="button"
          (click)="deleteClicked.emit(item); $event.stopPropagation()"
          data-cy="asset-type-delete"
        >
          <i class="ri-delete-bin-6-line"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
    <tr mat-row *matRowDef="let item; columns: visibleColumns"></tr>
  </table>
</div>
